import { render, staticRenderFns } from "./login-card.vue?vue&type=template&id=30baf9c9"
import script from "./login-card.vue?vue&type=script&lang=js"
export * from "./login-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports